import React from "react";
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import "../../styles/Shared/Shared.css";
import "../../styles/Expense_Tracker/Styles_Expenses_History.css"
import {Remove_Transaction_With_Firebase} from "../../actions/Transaction";

const Expenses_History = (props) => {
    return (
        <div className="expenses_history_container">
            <div className="expenses_history_main">
                <p className="title">History</p>
                <hr/>
                <div className="expenses_history_collection">
                    {
                        props.Transaction.length !== 0 ? props.Transaction.map((transaction) => (
                            <div key={transaction.id} className="single_expense_history">
                                <NavLink className="transaction_name" to={`/edit_transaction/${transaction.id}`}>
                                    {transaction.transaction_name}
                                    <div className="transaction_amount">
                                        {transaction.transaction_amount}
                                    </div>
                                </NavLink>
                                <button onClick={() => {
                                    props.Remove_Transaction_With_Firebase({id: transaction.id})
                                }}>Remove</button>
                            </div>
                        )) : <p>Transaction history is empty</p>
                    }
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        Transaction: state.Transaction
        // The state comes from the store.getState() function of redux
        // When we use the connect function it will connect with the Provider component first
        // Then it get the state from store.getState()
        // mapStateToProps is basically provides the access of redux state to any functions that need to access the state
        // The name Transaction can be found from the Store Config
        // The name state.Transaction is the same name of the reducer name
        // Other name such as transaction name or transaction amount can be found inside the reducers actions
    }
};

const mapDispatchToProps = (dispatch) => ({
    Remove_Transaction_With_Firebase: ({id}) => dispatch(Remove_Transaction_With_Firebase({id}))
});

export default connect(mapStateToProps, mapDispatchToProps)(Expenses_History);